









































































































































import Vue from "vue";
import validateBeforeSubmit from "@components/mixin/validateBeforeSubmit.ts";
import SelectBox from "@components/elements/form/SelectBox.vue";

type ContactForm = {
  kind: string;
  user_name: string;
  user_email: string;
  subject: string;
  body: string;
}


type DataType = {
  contactForm: ContactForm
}

export default Vue.extend({
  components: {
    SelectBox
  },
  mixins: [validateBeforeSubmit],
  props: {
    contactJsonString: {
      type: String,
      required: true,
    },
    contactKindsJsonString: {
      type: String,
      required: true,
    },
  },
  data(): DataType {
    const contactKinds = JSON.parse(this.contactKindsJsonString);
    const contactForm = JSON.parse(this.contactJsonString);

    return {
      contactKinds,
      contactForm
    };
  },
});
